import React, { useMemo } from 'react';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';

import JobFormPage from '../JobFormPage';
import { useRequirementsAndPayContext } from './context';
import {
    deduplicateQualifications,
    ensureRatesExist,
    filterQualificationsToCopyFromInitialScale,
} from './utils/manage';
import { RequirementsHeader } from './requirementComponents/RequirementsHeader';
import { RequirementsQuestions } from './requirementComponents/RequirementsQuestions';
import { DEGREE, ECE_DEGREE } from './constants';
interface PayPageProps {
    name: string;
}

export function Requirements({ name }: PayPageProps) {
    const { goToNext } = useJobFormContext();

    const { scales, replaceAllScales, initialScale } = useRequirementsAndPayContext();
    const qualificationsToCopy = useMemo(
        () => filterQualificationsToCopyFromInitialScale(initialScale, scales, [DEGREE, ECE_DEGREE]),
        [initialScale, scales],
    );

    function validateScales() {
        const newScales = ensureRatesExist(scales).map((x) => {
            return {
                ...x,
                qualifications: deduplicateQualifications([...qualificationsToCopy, ...x.qualifications]),
            };
        });
        replaceAllScales(newScales);
    }

    function onNext() {
        validateScales();
        goToNext('pay-page');
    }

    return (
        <JobFormPage id={name} onNextClicked={onNext} nextDisabled={false} nextText={'Next'}>
            <div style={{ width: '100%' }}>
                <RequirementsHeader />
                <RequirementsQuestions />
            </div>
        </JobFormPage>
    );
}
